/**
 * Path definitions shared across components
 */

// Paths that use 2020 styling (legacy)
// All other paths use 2024 styling by default
export const oldStylePaths = [
  '/404/',
  '/coming-soon/',
  '/feature/scope-and-sequence-builder/',
  '/nsw/',
  '/nsw-roadshow/',
  '/other/resources/',
  '/other/start/',
  '/other/stile-x/',
  '/other/terms/',
  '/other/vr/',
  '/planning-is-done/',
  '/resources/ac8.4-2024/',
  '/resources/ac9.0-2024/',
  '/resources/ac9.0-2025/',
  '/resources/conasta-terms/',
  '/resources/ict-professionals/',
  '/resources/parents-and-guardians/',
  '/resources/planning-documents/',
  '/stile-x-digital/',
  '/what-is-stile/revision-and-mastery-tools/',
  '/who-we-are/apply/',
  '/who-we-are/contact/',
  '/who-we-are/effective-stilists/',
  '/who-we-are/engineering-at-stile/',
  '/who-we-are/gender-diversity-in-stem/',
  '/who-we-are/hiring-process/',
  '/who-we-are/join-the-team/',
  '/who-we-are/our-team/',
  '/who-we-are/our-why/',
  '/who-we-are/upcoming-events/',
  '/why-choose-stile/benefits/',
  '/why-choose-stile/evidence-of-efficacy/',
  '/why-choose-stile/evidence-of-success/',
  '/why-choose-stile/high-impact-teaching-strategies/',
  '/why-choose-stile/pilot/',
  '/why-choose-stile/steam/',
  '/why-choose-stile/stem/',
  '/why-choose-stile/what-teachers-are-saying/',
];

// Helper function to determine if a path uses 2024 styling (inverted from before)
export function matchesNewStylePath(path: string): boolean {
  // Homepage uses 2024 styling
  if (path === '/') {
    return true;
  }

  // Check if path matches any old style path
  const usesOldStyle = oldStylePaths.some((stylePath) => path.startsWith(stylePath));

  // Return true if it does NOT use old style (i.e., uses new style)
  return !usesOldStyle;
}
